import { useTranslation } from 'react-i18next';

import { RichTextEditor as BaseRichTextEditor } from '@valwin/facto/components';

export function LinkButton() {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.LinkButton
      button={{
        tooltip: t('richTextEditor link tooltip'),
        ariaLabel: t('richTextEditor link ariaLabel'),
      }}
      titles={{
        add: t('richTextEditor link addTitle'),
        edit: t('richTextEditor link editTitle'),
      }}
      placeholder={t('richTextEditor link placeholder')}
      actionButtons={{
        add: t('richTextEditor link add'),
        edit: t('richTextEditor link edit'),
        remove: t('richTextEditor link remove'),
        cancel: t('richTextEditor link cancel'),
      }}
      invalidUrlMessage={t('richTextEditor link invalidUrlMessage')}
    />
  );
}
